export default {
  data() {
    return {
      isLoadedRequiredData: false,
    };
  },
  async created() {
    if (this.$store.getters.isBase) {
      const ganttIds = this.$store.getters.getActiveGanttIdsByRoute;

      await this.$store.dispatch('columns/dynamicLoadValues', { ganttIds });
    }

    this.isLoadedRequiredData = true;
  },
};
